import { log, logError } from './utils.js';
import { state, __staticDispatch } from './globals.js';
import { _minifiedClazzNames } from './index.js';
const reply = (nonce, value, error) => {
    const message = { nonce: nonce, value: value, error: error };
    state.frame.postMessage(message, state.targetOrigin);
};
export const coreReceive = (nonce, name, minifiedClazz, args) => {
    const receiver = __staticDispatch[minifiedClazz];
    if (!receiver) {
        logError(`Unknown class receiver ${minifiedClazz}`);
        logError(`supported receivers: `);
        logError(JSON.stringify(_minifiedClazzNames));
        logError(__staticDispatch);
        return;
    }
    const propName = receiver.__rpc[name];
    log(`Received request for function ${name} (nonce=${nonce}, propName=${propName}, name=${name})`);
    const prop = receiver[propName];
    if (!prop) {
        logError(`Unknown function ${propName} (originally ${name}) available functions:`);
        logError(receiver.__rpc);
        return;
    }
    if (receiver.__args[name] !== args.length) {
        logError(`Function ${propName} expected ${receiver.__args[name]} args, but received ${args.length}`);
        return;
    }
    try {
        const retVal = prop.call(receiver, ...args);
        if (retVal instanceof Promise) {
            retVal.then((res) => {
                reply(nonce, res);
            }).catch((exc) => {
                reply(nonce, null, new Error(`error: ${exc}`));
            });
        }
        else {
            reply(nonce, retVal);
        }
    }
    catch (exc) {
        reply(nonce, null, new Error(`error: ${exc}`));
    }
};
export const coreDidReceiveMessage = (event) => {
    const message = event.data;
    coreReceive(message.nonce, message.name, message.class, message.args);
};
